import { render, staticRenderFns } from "./VerbalProcess.vue?vue&type=template&id=c2579124"
import script from "./VerbalProcess.vue?vue&type=script&lang=js"
export * from "./VerbalProcess.vue?vue&type=script&lang=js"
import style0 from "./VerbalProcess.vue?vue&type=style&index=0&id=c2579124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports